import CM                from '@emersya/mpa-components-manager-lib';

export interface ITableRowComponentConfiguration extends CM.Component.IConfiguration {
};

export class TableRowComponent extends CM.Component<
	TableRowComponent,
	ITableRowComponentConfiguration
>
{
	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : ITableRowComponentConfiguration
	)
	{
		super(descriptor, configuration);
	};
};
export namespace NS {
	export const Component = TableRowComponent;
	export type Component = TableRowComponent;
	export type Configuration = ITableRowComponentConfiguration;
}
;
import manifestXMLSource from './TableRow.xml';
import './TableRow.scss';

CM.declare({
	id :       'tableRow',
	type :     TableRowComponent,
	manifest : manifestXMLSource
});
